import React, { useContext } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
  InputBase,
  makeStyles,
  List,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import User from './User';

import { UsersContext } from '../context/UsersContext';
import { AuthContext } from '../context/AuthContext';

const useStyles = makeStyles((theme) => ({
  users_container: {
    gridArea: 'u',
    borderRight: '1px solid #ddd',
    display: 'grid',
    gridTemplateRows: '50px 1fr',
  },
  search: {
    position: 'relative',
    width: '90%',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: '1px solid #ddd',
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  inputRoot: { width: '100%' },
  usersList: {
    flex: 1,
    background: '#fff',
    overflowY: 'auto',
    padding: 0,
  },
  margin: {
    marginTop: 25,
    fontStyle: 'italic',
  },
}));

export default function AllUsers() {
  const { users: _users, USERS, isLoading } = useContext(UsersContext);
  const { currentUser } = useContext(AuthContext);
  const classes = useStyles();

  const [allUsers, setAllUsers] = _users;
  const users = allUsers.filter(({ uid }) => currentUser.uid !== uid);

  const handleSearch = (e) => {
    const { value } = e.target;

    if (value) {
      const regex = new RegExp(value.trim(), 'gi');
      setAllUsers(
        USERS.filter(
          ({ username, uid }) => regex.test(username) && currentUser.uid !== uid
        )
      );
    } else {
      setAllUsers(USERS.filter(({ uid }) => currentUser.uid !== uid));
    }
  };
  return (
    <div className={classes.users_container}>
      <div className={classes.searchContainer}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon htmlColor='#555' />
          </div>
          <InputBase
            placeholder='Search…'
            classes={{
              input: classes.inputInput,
              root: classes.inputRoot,
            }}
            inputProps={{ 'aria-label': 'search' }}
            onChange={handleSearch}
          />
        </div>
      </div>
      <List className={classes.usersList}>
        {!isLoading ? (
          users[0] ? (
            users.map(({ username, joined, uid }) => (
              <User username={username} joined={joined} uid={uid} key={uid} />
            ))
          ) : (
            <Typography
              align='center'
              className={classes.margin}
              variant='subtitle2'
              color='textSecondary'
            >
              No user found
            </Typography>
          )
        ) : (
          <Typography
            align='center'
            className={classes.margin}
            variant='subtitle2'
            color='textSecondary'
          >
            <CircularProgress color='secondary' size={16} /> Getting users...
          </Typography>
        )}
      </List>
    </div>
  );
}
